import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})

export class GraficoServices {

    constructor(private http: HttpClient, private util: UtilService){}

    public buscaDados(numMes):Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/Logado/Grafico/BuscaDados`,{params:{numMes:numMes}})
    }
}
